<div class="h-100 w-100 d-flex flex-column justify-content-between lightbluebg" >

    <div class="h-100 p-x-page-thanks d-flex flex-column flex-nowrap justify-content-center" >
      <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <!--<span class="bticino-ico animazione-finale"></span>-->
        <!--<video width="200" height="200" [autoplay]="true" [muted]="true" playsinline loop>
            <source src="{{ videoURL }}" type="video/mp4">
             Your browser does not support the video tag. 
        </video>-->
        <img width="200" height="200" src="../assets/video/thanks.gif">
      </div>
      <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <h1 class="accent">
          {{ thanksTitle | translate }}
        </h1>
      </div>
      <div class="row text-center d-flex flex-column flex-nowrap justify-content-center align-items-center">
        <h4 class="font-weight-normal m-0 text-center">
          {{ thanksText | translate }}
        </h4>
        <h4 *ngIf="sharewithInstaller" class="m-0 text-center"><a (click)='goToSharePage()' class="font-weight-bold m-0 text-center link-underline">
          {{ thanksTextBold | translate }}
        </a></h4>
      </div>
      <!--<div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <h4 class="font-weight-normal m-0 text-center">
          <i>
            <b>
              {{ "b2c.IDS_THANKS_TEXT_2" | translate }}
            </b>
          </i>
        </h4>
      </div>-->
      <!--<div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center cursor-pointer m-t-brochure">
        <span class="d-block fake-anchor d-inline-block font-bticino-bold text-uppercase">
          <u>{{ "b2c.IDS_BROCHURE" | translate }}</u>
          &nbsp;
        </span>
        <span class="bticino-ico arrow-right grey d-inline-block small deg-90"></span>
      </div>-->
    </div>

    <div class="p-x-page-thanks d-flex flex-column align-items-center justify-content-between thanks-footer border">
      <span class="d-block font-bticino-bold m-b-24">
        {{ "b2c.FOLLOW_US" | translate }}
      </span>
      <div class="d-flex justify-content-center">
        <a href="https://www.facebook.com/BticinoSocial/" class="bticino-ico social-fb cursor-pointer zoom" style="width: 11px; height: 24px;"></a>
        <a href="https://www.youtube.com/c/bticino/" class="bticino-ico social-yt cursor-pointer zoom m-x-27" style="width: 34px; height: 24px;"></a>
        <a href="https://www.instagram.com/bticinosocial/" class="bticino-ico social-insta cursor-pointer zoom" style="width: 24px; height: 24px;"></a>
      </div>
    </div> 
    <!--<div id="smcx-sdk"></div>-->
</div>
